<template>
    <div class="container">
        <template v-if="permitMarketer">
            <!-- import and display user earnings here -->
            <app-display-earnings :earnedObj="myReferredUsers.earned"></app-display-earnings>

            <!-- import and display user referral link here -->
            <app-referral-link></app-referral-link>

            <!-- marketers daily list of referred user -->
            <div class="row my-3">
                <div class="col-12">
                    <div class="card bg-white">
                        <div class="card-body">
                            <form v-if="user">
                                <dl class="row mb-0">
                                    <dt class="col-12">
                                        <div class="float-left">
                                            <h5 @click.prevent="showReferrals = !showReferrals" class="text-dark-green nav-settings-head clickable m-0">
                                                <!-- dynamically render the marketers name! beneficial to state-reps -->
                                                <span v-if="myReferredUsers && loadedReferrals && this.$route.params.userId">
                                                    <i class="fas fa-users"></i> {{myReferredUsers.marketer.name | capitalize}}
                                                </span>
                                                <span v-else>
                                                    <span v-if="showReferrals">My Referrals</span>
                                                    <span v-else>My Referrals</span>
                                                </span>
                                                <span v-if="myReferredUsers && loadedReferrals" class="ml-1 badge badge-light">{{myReferredUsers.referred.length}}</span>
                                            </h5>
                                        </div>
                                        <div class="float-right clickable">
                                            <small v-if="!showReferrals" @click="showReferrals = true">
                                                Show <i class="fas fa-eye"></i>
                                            </small>
                                            <small v-else @click="showReferrals = false">
                                                Hide <i class="fas fa-eye-slash"></i>
                                            </small>
                                        </div>
                                    </dt>
                                </dl>
                                <div v-if="showReferrals" class="table-responsive mt-1">
                                    <!-- message to all regaridng refer and earn REMOVE AFTER REFER AND EARN -->
                                    <div class="text-danger text-center mb-2">
                                        <small>
                                            Showing only referals made from March 6th, 2021 EST till date.
                                            For older referrals, click your account photo > settings > handle.
                                        </small>
                                    </div>
                                    <table class="table table-striped">
                                        <thead class="bg-silver">
                                            <tr>
                                                <th scope="col">No.</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Referred</th>
                                                <th scope="col">Posted Item</th>
                                                <th scope="col">aTrue Member</th>
                                                <th scope="col">Met T&amp;C?</th>
                                                <th scope="col">Earned</th>
                                                <!-- <th scope="col">Paid</th> -->
                                            </tr>
                                        </thead>
                                        <tbody v-if="loadedReferrals">
                                            <tr v-for="(referred, i) in myReferredUsers.referred" :key="i">
                                                <td>{{i + 1}}.</td>
                                                <td v-if="referred.handle" class="text-capitalize">
                                                    <router-link :to="{ name: 'user-handle', params: { handle: referred.handle } }"> 
                                                        {{referred.name}} 
                                                        <span class="text-dark-green text-lowercase mx-1">@{{referred.handle}}</span>
                                                    </router-link> 
                                                </td>
                                                <td v-else>{{referred.email}}</td>
                                                <td>{{referred.joined | moment("MMM D 'YY HH:MM")}}</td>
                                                <td>
                                                    <span v-if="referred.postedItem" class="text-dark-green">Yes</span>
                                                    <span v-else class="text-danger">No</span>
                                                </td>
                                                <td>
                                                    <span v-if="referred.aTrueMember" class="text-dark-green">Yes</span>
                                                    <span v-else class="text-danger">No</span>
                                                </td>
                                                <td>
                                                    <span v-if="referred.metTandC" class="text-dark-green">Yes</span>
                                                    <span v-else class="text-danger">No</span>
                                                </td>
                                                <td>
                                                    <span v-if="referred.earned" class="text-dark-green">NGN {{referred.payableAmt}}</span>
                                                    <span v-else class="text-danger">NGN 0</span>
                                                </td>
                                                <!-- intentionally commented out real-time payment - 
                                                    since all payments will be at the end of the event -->
                                                <!-- <td>
                                                    <span v-if="referred.paid.mktPaid" class="text-dark-green">
                                                        Yes {{referred.paid.mktPaidTime | moment("MMM D 'YY")}}
                                                    </span>
                                                    <span v-else class="text-danger">No</span>
                                                </td> -->
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <!-- loading marketer referrals -->
                                            <tr v-if="loadingReferrals">
                                                <td colspan="7">Fetching your referrals, please wait...</td>
                                            </tr>
                                            <!-- marketer referrals not available -->
                                            <tr v-else>
                                                <td colspan="7" class="text-danger">You haven't referred anyone yet!</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- import scroll table message -->
                                    <app-table-scroll-msg></app-table-scroll-msg>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="row mt-3">
                <div class="col-12 text-center text-danger">
                    <h3>Insufficient Permissons!!!</h3>
                    <p>You're unauthorized to access marketers page, contact support to request access.</p>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { copyTextFxn } from '@/store/dry'
import TableScrollMsg from '@/components/user/shared/TableScrollMsg.vue' // REMOVE AFTER REFER AND WIN
import LayoutUser from '@/layouts/User.vue'
import DisplayEarnings from './DisplayEarnings.vue'
import ReferralLink from './ReferralLink.vue'

export default {
    name: "Marketers",
    data() {
        return {
            showReferrals: true,
            loadingReferrals: false,
            loadedReferrals: false,
            showNotations: false,
            copied: false
        }
    },
    methods: {
        ...mapActions(['fetchMktReferrals']),
        runFetchMktReferrals(theUserId) {
            let userObj = {
                userId: theUserId // marketerId
            }
            this.fetchMktReferrals(userObj).then(() => {}).catch((e) => {})
        },
        runLoadingReferrals() {
            setTimeout(() => {
                this.loadingReferrals = false
            }, 10000);
            this.loadingReferrals = true
        },
        copyURL() {
            this.copied = true
            setTimeout(() => {
                this.copied = false
            }, 1000)
            copyTextFxn(this.$refs.myRefLink.innerText)
        }
    },
    computed: {
        ...mapGetters(['user', 'setMktReferrals']),
        myReferredUsers() {
            if(this.setMktReferrals && this.setMktReferrals !== null) {
                // will return an object containing marketer: {} and referred: []
                return this.setMktReferrals
            }
            return false
        },
        permitMarketer() {
            this.loadedReferrals = false
            if(this.user && this.user.roles){
                let userRoles = this.user.roles
                let portalRoles = this.$route.params.userId ? [process.env.VUE_APP_SRP_ROLE] : [process.env.VUE_APP_RFR_ROLE]
                // js some() fxn returns true if some of the el in arry one exists in array two
                let rolesCheck = userRoles.some((val) => portalRoles.indexOf(val) !== -1);  
                if(rolesCheck !== false){
                    setTimeout(() => {
                        // if a marketers table is being looked up
                        if(this.$route.params.userId){
                            this.runFetchMktReferrals(this.$route.params.userId)
                        } else {
                            this.runFetchMktReferrals(this.user._id)
                        }
                        // display the loaded marketer table
                        this.loadedReferrals = true
                    }, 2000);
                    return true
                }
            }
            return false
        },
        myReferralLink() {
            if(this.user && this.user.userHandle){
                return `${process.env.VUE_APP_CLT_URL}/${this.user.userHandle}/refer-a-friend`
            }
            return false
        },
    },
    components: {
        appTableScrollMsg: TableScrollMsg, // REMOVE AFTER REFER AND WIN
        appDisplayEarnings: DisplayEarnings,
        appReferralLink: ReferralLink
    },
    mounted() {
        this.runLoadingReferrals()
    },
    created() {
        this.$emit('update:layout', LayoutUser);
        /**
         *  git add .
            git commit -m "
            git push
            git checkout production
            git merge secondBuild
            git checkout secondBuild
            npm run serve
         */
    }
}
</script>